import { useParams } from 'react-router-dom';
import FacebookPostsPanel from '../../../components/FacebookPostsPanel';

export default function PostsRoute() {
  const { botId } = useParams<{ botId: string }>();
  if (!botId) return null;
  return <FacebookPostsPanel botId={botId} />;
}
